export default class Utility {

    /**
     * TODO: fix timezone.
     */
    static unixToDateTime(unix) {

        let date = new Date(unix * 1000);

        let hours = date.getHours();

        let minutes = "0" + date.getMinutes();

        let seconds = "0" + date.getSeconds();

        return date.getFullYear() + '/'
            + (Number(date.getMonth())+1) + '/'
            + date.getDate() +' '
            + hours + ':'
            + minutes.substr(-2)
            + ':' + seconds.substr(-2);

    }
}